(function () {
  'use strict';
  function init(section) {
    if (!section || section.dataset.wolziChartReady === 'true') return;
    var details = section.querySelector('.product-details') || section;
    var tables = Array.from(details.querySelectorAll('table'));
    var measure = /\b(bust|chest|waist|hip|length|sleeve|shoulder|inseam|outseam|rise|thigh|hem|cuff|arm|foot|height|width|neck|collar|circumference|underbust|under bust|leg opening|calf|wrist|ankle|palm|back|front|body|skirt|dress|pants|pant|shorts|coat|shirt|jacket|top|bottom|garment|strap|cup)\b/i;
    var exclude = /\b(us|uk|eu)\s*size\b|recommended\s*weight|\bweight\b|^size(?:\s*\/\s*(?:inches?|cm|centimeters?))?$/i;
    function headerRows(table) {
      var rows = Array.from(table.rows);
      if (!rows.length) return [];
      if (table.tHead && table.tHead.rows.length) return Array.from(table.tHead.rows);
      var result = [rows[0]];
      if (rows[1] && /flat|stretch|relaxed|extended|unstretched/i.test(rows[1].textContent || '') && measure.test(rows[0].textContent || '')) result.push(rows[1]);
      return result;
    }
    function headers(table, heads) {
      var cols = [];
      heads.forEach(function (row) {
        var col = 0;
        Array.from(row.cells).forEach(function (cell) {
          var span = Math.max(1, Number(cell.colSpan) || 1);
          var label = (cell.textContent || '').replace(/\s+/g, ' ').trim();
          for (var n = 0; n < span; n++) {
            if (!cols[col + n]) cols[col + n] = [];
            if (label) cols[col + n].push(label);
          }
          col += span;
        });
      });
      return cols.map(function (parts) { return (parts || []).join(' ').replace(/\s+/g, ' ').trim(); });
    }
    function inspect(table) {
      var heads = headerRows(table);
      if (!heads.length) return null;
      var labels = headers(table, heads);
      var columns = [];
      labels.forEach(function (label, i) {
        if (label && !exclude.test(label) && !/\b(recommended\s*weight|weight|us\s*size|uk\s*size|eu\s*size)\b/i.test(label) && measure.test(label)) columns.push(i);
      });
      if (!columns.length) return null;
      var hasSizeHeader = labels.some(function (label) { return /\b(size|us size|uk size|eu size)\b/i.test(label); });
      var body = Array.from(table.rows).slice(heads.length);
      var hasSizeRows = body.slice(0, 4).some(function (row) {
        var value = row.cells[0] ? (row.cells[0].textContent || '').trim() : '';
        return /^(XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL|4XL|ONE SIZE|FREE SIZE|\d{1,2}(?:\/\d{1,2})?)$/i.test(value);
      });
      return hasSizeHeader || hasSizeRows ? { heads: heads, columns: columns } : null;
    }
    var table = null, info = null;
    for (var i = 0; i < tables.length; i++) {
      var found = inspect(tables[i]);
      if (found) { table = tables[i]; info = found; break; }
    }
    if (!table || !info) return;
    var source = String(section.dataset.sizeChartUnit || 'in').toLowerCase();
    source = source === 'cm' || source.indexOf('centimeter') === 0 ? 'cm' : 'in';
    var rowStart = info.heads.length;
    var rows = Array.from(table.rows);
    info.columns.forEach(function (index) {
      rows.slice(rowStart).forEach(function (row) {
        var cell = row.cells[index];
        if (cell && !Object.prototype.hasOwnProperty.call(cell.dataset, 'wolziOriginalText')) cell.dataset.wolziOriginalText = cell.textContent || '';
      });
    });
    var controls = document.createElement('div');
    controls.className = 'wolzi-size-chart-controls';
    controls.setAttribute('aria-label', 'Size chart measurement units');
    controls.innerHTML = '<div class="wolzi-size-chart-heading">Size Guide</div><div class="wolzi-size-chart-unit-switch" role="group" aria-label="Choose measurement unit"><button type="button" class="wolzi-size-chart-unit" data-unit="in" aria-pressed="false">Inches (in)</button><button type="button" class="wolzi-size-chart-unit" data-unit="cm" aria-pressed="false">Centimeters (cm)</button></div>';
    function format(value, unit) {
      var rounded = Number(value.toFixed(unit === 'in' ? 2 : 1));
      return String(rounded);
    }
    function render(unit) {
      info.columns.forEach(function (index) {
        rows.slice(rowStart).forEach(function (row) {
          var cell = row.cells[index];
          if (!cell || !Object.prototype.hasOwnProperty.call(cell.dataset, 'wolziOriginalText')) return;
          var original = cell.dataset.wolziOriginalText;
          cell.textContent = unit === source ? original : original.replace(/[-+]?(?:\d+\.?\d*|\.\d+)/g, function (match) {
            var value = Number(match);
            return Number.isFinite(value) ? format(unit === 'cm' ? value * 2.54 : value / 2.54, unit) : match;
          });
        });
      });
      info.heads.forEach(function (row) {
        Array.from(row.cells).forEach(function (cell) {
          if (!Object.prototype.hasOwnProperty.call(cell.dataset, 'wolziOriginalHeaderText')) {
            cell.dataset.wolziOriginalHeaderText = cell.textContent || '';
          }
          var originalHeader = cell.dataset.wolziOriginalHeaderText.replace(/\s*\((?:in|cm)\)\s*/gi, '').replace(/\s+/g, ' ').trim();
          var isMeasurementHeader = measure.test(originalHeader) && !exclude.test(originalHeader) &&
            !/\b(recommended\s*weight|weight|us\s*size|uk\s*size|eu\s*size)\b/i.test(originalHeader);
          if (isMeasurementHeader) {
            cell.textContent = originalHeader + ' (' + String(unit).toLowerCase() + ')';
          } else {
            cell.textContent = cell.dataset.wolziOriginalHeaderText;
          }
        });
      });
      controls.querySelectorAll('[data-unit]').forEach(function (button) {
        var active = button.dataset.unit === unit;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    controls.querySelectorAll('[data-unit]').forEach(function (button) {
      button.addEventListener('click', function () { render(button.dataset.unit); });
    });
    table.classList.add('wolzi-size-chart-table');
    table.insertAdjacentElement('beforebegin', controls);
    var picker = section.querySelector('.variant-picker[data-template-product-match="true"]') || section.querySelector('.variant-picker');
    if (!section.querySelector('.wolzi-size-chart-note')) {
      var note = document.createElement('span');
      note.className = 'wolzi-size-chart-note';
      note.textContent = '(See Size Chart Below)';
      var sizeLegend = picker ? Array.from(picker.querySelectorAll('legend')).find(function (legend) {
        return /^\s*size\s*$/i.test((legend.textContent || '').trim());
      }) : null;
      if (sizeLegend) {
        note.classList.add('wolzi-size-chart-note-inline');
        sizeLegend.appendChild(document.createTextNode(' '));
        sizeLegend.appendChild(note);
      } else if (picker) {
        note.classList.add('wolzi-size-chart-note-fallback');
        picker.insertAdjacentElement('afterend', note);
      } else {
        note.classList.add('wolzi-size-chart-note-fallback');
        controls.insertAdjacentElement('beforebegin', note);
      }
    }
    section.dataset.wolziChartReady = 'true';
    render('in');
  }

  function initAll() {
    // Initialize only the dedicated product-information wrapper. Initializing
    // both it and an outer Shopify section duplicates the unit-switch controls.
    document.querySelectorAll('[data-wolzi-size-chart]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();